import React, { useEffect, useState } from "react";
import "./layout.css";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import NotificationBell from "../notifications/NotificationBell";
import MenuIcon from "@mui/icons-material/Menu";
import Sidebar from "../sidebar/Sidebar";
// import { Box } from "@mui/system";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Input,
  InputLabel,
  Menu,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { ReactComponent as CalendarIcon } from "../../Assets/images/calender.svg";
import { logout, updateUser, userFlagOff } from "../../Redux/Actions/userAction";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "@mui/material";
import { imgUrl } from "../../api/api";
import toast from "react-hot-toast";
function Layout({ children, title, user }) {
  const isMobileDrawer = useMediaQuery('(max-width:480px)');
  const isNarrowForDate = useMediaQuery('(max-width:1100px)');
  const showShortDate = isMobileDrawer || isNarrowForDate;
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const {isUserAdded}=useSelector(state=>state.User);
  const [day, setDay] = useState("");
  const [date, setDate] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [openProfileDialog, setOpenProfileDialog] = useState(false);
  const [username,setUsername]=useState(user.username);
  const [password,setPassword]=useState(user.password);
  const [confirmpassword,setConfirmPassword]=useState('');
  const [email,setEmail]=useState(user.email);
  const open = Boolean(anchorEl);
  const [image,setImage]=useState(`${imgUrl}/${user?.image?.url}`);
  const [imgFile,setImgFile]=useState('');
  useEffect(()=>{
    if(isUserAdded){
      toast.success('User updated!');
      setOpenProfileDialog(false);
      dispatch(userFlagOff());
    }
  },[isUserAdded])
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (type, obj) => {
    setAnchorEl(null);
    // setOpenProfileDialog(true);
  };
  const openprofile = () => {
    setAnchorEl(null);
    setOpenProfileDialog(true);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    getDay();
  }, []);
  const getDay = () => {
    const date = new Date();
    setDate(date.getDate());
    setYear(date.getFullYear());
    console.log("day", date.getDay());
    switch (date.getDay()) {
      case 1:
        setDay("Monday");
        break;
      case 2:
        setDay("Tuesday");
        break;
      case 3:
        setDay("Wednesday");
        break;
      case 4:
        setDay("Thursday");
        break;
      case 5:
        setDay("Friday");
        break;
      case 6:
        setDay("Saturday");
        break;
      case 0:
        setDay("Sunday");
        break;
      default:
        setDay("");
    }
    switch (date.getMonth()) {
      case 0:
        setMonth("Jan");
        break;
      case 1:
        setMonth("Feb");
        break;
      case 2:
        setMonth("Mar");
        break;
      case 3:
        setMonth("Apr");
        break;
      case 4:
        setMonth("May");
        break;
      case 5:
        setMonth("Jun");
        break;
      case 6:
        setMonth("Jul");
        break;
      case 7:
        setMonth("Aug");
        break;
      case 8:
        setMonth("Sep");
        break;
      case 9:
        setMonth("Oct");
        break;
      case 10:
        setMonth("Nov");
        break;
      case 11:
        setMonth("Dec");
        break;
      default:
        setMonth("");
    }
  };
  const browseUserImage=(e)=>{
    setImage(URL.createObjectURL(e.target.files[0]));
    setImgFile(e.target.files[0]);
    console.log('browse function=>',imgFile)
  }
  const headerDateCompact = `${String(day).slice(0, 3)} ${date} ${month} ${year}`;
  const fullDateTitle = `${day}, ${date} ${month} ${year}`;

  const accountMenuEl = (
    <Menu
      id="content-menu"
      anchorEl={anchorEl}
      open={open}
      MenuListProps={{ "aria-labelledby": "content-menu-btn" }}
      onClose={handleClose}
      keepMounted
      anchorOrigin={isMobileDrawer ? { vertical: "bottom", horizontal: "right" } : { vertical: "bottom", horizontal: "right" }}
      transformOrigin={isMobileDrawer ? { vertical: "top", horizontal: "right" } : { vertical: "top", horizontal: "right" }}
    >
      <MenuItem onClick={openprofile}>Profile</MenuItem>
      <MenuItem onClick={() => dispatch(logout())}>Logout</MenuItem>
    </Menu>
  );

  const metaClusterEl = (
    <div className={`header-action-cluster${isMobileDrawer ? "" : " header-action-cluster--toolbar"}`}>
      <Box
        component="span"
        title={fullDateTitle}
        aria-label={`Today: ${fullDateTitle}`}
        sx={{ display: "flex", alignItems: "center", gap: 0.5, minWidth: 0, pr: 0.5 }}
      >
        <CalendarIcon sx={{ color: "#551fff", width: isMobileDrawer ? 18 : 20, height: isMobileDrawer ? 18 : 20, flexShrink: 0 }} />
        <Typography
          sx={{ fontSize: isMobileDrawer ? "11px" : showShortDate ? "12px" : "13px", fontWeight: 600, color: "#374151", lineHeight: 1.25 }}
          noWrap
        >
          {showShortDate ? headerDateCompact : fullDateTitle}
        </Typography>
      </Box>
      <span className="header-cluster-divider" aria-hidden />
      <div className="header-cluster-profile">
        {!user?.image?.url ? (
          <AccountCircleIcon
            style={{ color: "#551fff", fontSize: isMobileDrawer ? 28 : 30 }}
            onClick={handleClick}
            aria-controls={open ? "content-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            id="content-menu-btn"
          />
        ) : (
          <img
            src={`${imgUrl}/${user?.image?.url}`}
            alt=""
            style={{ height: isMobileDrawer ? 28 : 30, width: isMobileDrawer ? 28 : 30, borderRadius: "50%", cursor: "pointer", objectFit: "cover" }}
            onClick={handleClick}
            aria-controls={open ? "content-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            id="content-menu-btn"
          />
        )}
        <Typography
          sx={{
            pl: "4px",
            color: "#6B7A99",
            fontSize: isMobileDrawer ? "12px" : "13px",
            fontWeight: 600,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            minWidth: 0,
            flex: 1,
            maxWidth: isMobileDrawer ? 96 : 200,
          }}
          title={user?.username}
        >
          {user?.username}
        </Typography>
      </div>
      <span className="header-cluster-divider" aria-hidden />
      <NotificationBell user={user} size={isMobileDrawer ? 20 : 22} />
    </div>
  );

  const update=()=>{
    // console.log('update function=>',imgFile)
    const form=new FormData();
    form.append('username',username);
    form.append('password',password);
    form.append('email',email);
    form.append('content',imgFile);
    dispatch(updateUser(user._id,form));
  }
  return (
    <>
      <div className="layout-container">
        {/* Mobile sidebar overlay */}
        {isMobileDrawer && sidebarOpen && (
          <div className="sidebar-overlay sidebar-overlay--visible" onClick={() => setSidebarOpen(false)} />
        )}
        <div className={`side-bar${isMobileDrawer && sidebarOpen ? ' side-bar--open' : ''}`}>
          <Sidebar user={user} onNavigate={() => setSidebarOpen(false)} />
        </div>
        <div className="body">
          <div className={`body-header${isMobileDrawer ? " mobile-drawer-mode" : " body-header--unified"}`}>
            {isMobileDrawer ? (
              <>
                <div className="body-header-mobile-row1">
                  <button type="button" className="hamburger-btn" aria-label="Open menu" onClick={() => setSidebarOpen(!sidebarOpen)}>
                    <MenuIcon style={{ fontSize: 26 }} />
                  </button>
                  {metaClusterEl}
                  {accountMenuEl}
                </div>
                <div className="body-header-mobile-row2">
                  <div className="title-logo title-logo--sm" />
                  <h1 className="form-title form-title--mobile">{title}</h1>
                </div>
              </>
            ) : (
              <>
                <div className="body-header-left">
                  <div className="title-logo" />
                  <p className="form-title form-title--toolbar">{title}</p>
                </div>
                {metaClusterEl}
                {accountMenuEl}
              </>
            )}
          </div>
          <div className="body-body">
            <div className="body-body-scroll-able">{children}</div>
          </div>
        </div>
      </div>

      <Dialog
        maxWidth={"lg"}
        open={openProfileDialog}
        onClose={() => setOpenProfileDialog(false)}
        sx={{
          zIndex:'100000000'
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "7px solid #551fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <img src={"/images/userOutlinedColorIcon.png"} />
          <Typography
            sx={{
              fontFamily: "Open Sans",
              fontStyle: "normal",
              fontWeight: 700,
              fontSize: "26px",
              lineHeight: "35px",
              color: "#15192C",
            }}
          >
            User Profile
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              width: { xs: "85vw", sm: "70vw", md: "50vw" },
              height: { xs: "auto", md: "40vh" },
              padding: { xs: "10px", md: "20px" },
            }}
          >
            <Box
              sx={{
                height: "100%",
                width: "100%",
                // border: "1px solid black",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  height: "80%",
                  width: "100%",
                  // border: "1px solid black",
                  display: "flex",
                }}
              >
                <Box
                  sx={{
                    height: "100%",
                    width: "30%",
                    // borderLeft: "1px solid black",
                  }}
                >
                  <Box
                    sx={{
                      height: "100%",
                      width: "95%",
                      borderRadius: "20px",
                    }}
                  >
                    <img
                      src={
                       `${image}`
                      }
                      alt='/images/LEEDOIT.png'
                      style={{
                        height: "100%",
                        width: "100%",
                        borderRadius: "15px",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                </Box>
                <Box
                  sx={{
                    height: "100%",
                    width: "70%",
                    // borderLeft: "1px solid black",
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                  }}
                >
                  <FormControl variant={'standard'} fullWidth>
                  <InputLabel htmlFor="username">Username *</InputLabel>
                  <Input
                  id={'username'}
                  name="username"
                    type={"text"}
                    value={username}
                    onChange={(e)=>setUsername(e.target.value)}
                  />
                  </FormControl>
                  <FormControl variant={'standard'} fullWidth>
                  <InputLabel htmlFor='password'>Password *</InputLabel>
                  <Input
                  id="password"
                  name="password"
                    type={"password"}
                    value={password}
                    onChange={(e)=>setPassword(e.target.value)}
                  />
                  </FormControl>
                  <FormControl variant={'standard'} fullWidth>
                  <InputLabel htmlFor="cpassword">Confirm Password *</InputLabel>
                  <Input
                  id='cpassword'
                    type={"password"}
                    value={confirmpassword}
                    onChange={(e)=>setConfirmPassword(e.target.value)}
                  />
                  </FormControl>
                  <FormControl variant={'standard'} fullWidth>
                    <InputLabel htmlFor="email">Email *</InputLabel>
                  <Input
                    id="email"
                    type={"email"}
                    value={email}
                    onChange={(e)=>setEmail(e.target.value)}
                  />
                  </FormControl>
                </Box>
              </Box>
              <Box
                sx={{
                  height: "20%",
                  width: "100%",
                  // border: "1px solid black",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <input hidden type="file" id="imagebrowse" onChange={browseUserImage}/>
                <Button
                  variant={"outlined"}
                  sx={{
                    borderRadius: "6px",
                    textTransform: "capitalize",
                    color: "#551FFF",
                    border: "1px solid #551FFF",
                    width: "170px",
                  }}
                  onClick={()=>
                  document.getElementById('imagebrowse').click()
                  }
                >
                  Upload Profile Photo
                </Button>
                <Button
                  variant={"contained"}
                  sx={{
                    borderRadius: "6px",
                    textTransform: "capitalize",
                    color: "#ffffff",
                    background: "#551FFF",
                    width: "170px",
                  }}
                  onClick={update}
                >
                  Save
                </Button>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
export default Layout;
